function initBundleCart(root = document) {
  root.querySelectorAll('[data-bundle-recommendation]').forEach(card => {
    if (card.dataset.ready) return;
    card.dataset.ready = 'true';
    const select = card.querySelector('[data-bundle-variant]');
    const button = card.querySelector('[data-bundle-add]');
    const status = card.querySelector('[data-bundle-status]');
    const estimate = card.querySelector('[data-bundle-estimate]');
    const link = card.querySelector('[data-bundle-link]');
    if (!select || !button) return;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: card.dataset.currency});
    function update() {
      const option = select.selectedOptions[0];
      if (!option) return;
      button.disabled = option.disabled;
      if (estimate) estimate.textContent = money.format((Number(card.dataset.existingSaving) + Math.floor(Number(option.dataset.price) / 10)) / 100);
      if (link) { const url = new URL(link.href); url.searchParams.set('variant', option.value); link.href = url.href; }
    }
    button.hidden = false;
    select.addEventListener('change', update);
    button.addEventListener('click', async () => {
      if (button.disabled) return;
      button.disabled = true;
      status.hidden = false;
      status.textContent = card.dataset.adding;
      const cartRoot = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(cartRoot + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(select.value),quantity:1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || card.dataset.error);
        window.location.assign(cartRoot + 'cart');
      } catch (error) {
        status.textContent = error.message || card.dataset.error;
        button.disabled = false;
      }
    });
    update();
  });
}
document.addEventListener('DOMContentLoaded', () => initBundleCart());
document.addEventListener('shopify:section:load', event => initBundleCart(event.target));
